export const baseButtonStyles = `
  mt-[30px] rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500
`;

export const outlineButtonStyles = `
  ${baseButtonStyles} border-gray-300 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]
`;

export const solidButtonStyles = (
    color = '#FEBF3E',
    hoverColor = '#E6F7F8'
) => `
  ${baseButtonStyles} border-[${color}] bg-[${color}] hover:border-[${hoverColor}] hover:bg-[${hoverColor}]
`;

export const disabledButtonStyles = `
  ${baseButtonStyles} 
  cursor-not-allowed 
  opacity-50 
  pointer-events-none 
  hover:border-none 
  hover:bg-none 
  hover:!border-transparent 
  hover:!bg-transparent
`;
